import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-content" }
const _hoisted_2 = ["innerHTML"]

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'errorMessage',
  props: {
	text: {
		type: String,
		required: true
	},
	duration: {
		type: Number,
		default: 5000
	}
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isVisible = ref(false);
let timeoutId: number | null = null;

const messageStyle = computed(() => ({
	position: 'fixed',
	bottom: '20px',
	right: '20px',
	backgroundColor: 'rgba(255, 155, 155, 0.92)',
	color: 'black',
	padding: '15px',
	borderRadius: '8px',
	maxWidth: '600px',
	zIndex: '3000',
	boxShadow: '0 2px 12px rgba(0, 0, 0, 0.15)'
}));

const show = () => {
	isVisible.value = true;
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
	timeoutId = window.setTimeout(() => {
		close();
	}, props.duration);
};

const close = () => {
	isVisible.value = false;
	if (timeoutId) {
		clearTimeout(timeoutId);
		timeoutId = null;
	}
	emit('close');
};

watch(() => props.text, (newText) => {
	if (newText) {
		show();
	} else {
		close();
	}
}, { immediate: true });

onUnmounted(() => {
	if (timeoutId) {
		clearTimeout(timeoutId);
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (isVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "error-message",
            style: _normalizeStyle(messageStyle.value)
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", { innerHTML: __props.text }, null, 8, _hoisted_2),
              _createElementVNode("button", {
                class: "close-button",
                onClick: close
              }, "×")
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})